import './styles/Login.scss';
import { App_ViewModeMap, OTP_ModeMap, Login_PageModeMap, MemberUser_TypeMap, OtherUserInfo_StatusMap, MemberUser_StatusMap, System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext, ExAppContext } from '../Context';
import { Fragment, useContext, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { Browser } from '@capacitor/browser';
import CryptoJS from 'crypto-js';
import ToggleSlider from '../components/ToggleSlider';

//graphics
// import PPKMLogo from '../assets/images/logos/ppkmLogo1.jpg';
import PPKMLogo from '../assets/images/logos/ppkmLogo1_transparent.png';

//mui icons
//MEMBERSHIP_SELECTION
import EmailIcon from '@mui/icons-material/Email';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import KeyIcon from '@mui/icons-material/Key';
import HelpIcon from '@mui/icons-material/Help';

//classes
import MemberUser from '../classes/memberUser';
import MemberType from '../exClasses/memberType';
import MembershipContract from '../exClasses/membershipContract';
import OtherUserInfo from '../exClasses/otherUserInfo';

//controllers
import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';
import ClassController from '../controllers/ClassController';
import HelperFunctionsController from '../controllers/HelperFunctionsController';

// class OtherUserInfo {
//     company_name: string = '';
//     member_typeID: string = '';
//     password: string = '';
//     status: number|null = null;
// } ---deprecated,moed to exClasses

interface Props {

}

const nonstate = {
    GRACE_LOGIN_LAST_DATE: "03-31" 
}

const Login: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState(0); //login, referralCode, forgotPassword
    const [loginEmail, SetLoginEmail] = useState('');
    //states - EMAIL_RETRIEVE
    const [emailRetrieveMemberID, SetEmailRetrieveMemberID] = useState('');
    const [emailRetrieveNRIC, SetEmailRetrieveNRIC] = useState('');
    //states - MEMBERSHIP_SELECTION
    const [retrievedMemberUsers, SetRetrievedMemberUsers] = useState([] as MemberUser[]);
    const [retrievedOtherUserInfos, SetRetrievedOtherUserInfos] = useState([] as OtherUserInfo[]);
    const [selectedLoginAttemptAccount, SetSelectedLoginAttemptAccount] = useState({} as MemberUser);
    const [selectedOtherUserInfo, SetSelectedOtherUserInfo] = useState({} as OtherUserInfo);
    //states - PASSWORD_LOGIN
    const [loginPassword, SetLoginPassword] = useState('');
    const [shouldShowLoginPassword, SetShouldShowLoginPassword] = useState(false);
    //states - PASSWORD_RESET
    const [resetNewPassword, SetResetNewPassword] = useState('');
    const [resetConfirmPassword, SetResetConfirmPassword] = useState('');
    const [resetNewPin, SetResetNewPin] = useState('');
    const [resetConfirmPin, SetResetConfirmPin] = useState('');
    const [shouldShowResetNewPassword, SetShouldShowResetNewPassword] = useState(false);
    const [shouldShowResetConfirmPassword, SetShouldShowResetConfirmPassword] = useState(false);
    const [shouldShowResetNewPin, SetShouldShowResetNewPin] = useState(false);
    const [shouldShowResetConfirmPin, SetShouldShowResetConfirmPin] = useState(false);
    const [enablePin, SetEnablePin] = useState<boolean>(false);
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    const classController_memberUser = new ClassController('MemberUser');
    const classController_otherUserInfo = new ClassController('OtherUserInfo');
    const helperFunctions = new HelperFunctionsController();
    //router objs
    const location = useLocation();
    //refs
    const pageRef = useRef<number>(page);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('LoginTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    // }, [appContext.databaseActionModeQueue]);

    //on page load auto checks is firstTimeUser
    useEffect(() => {
        AutoLogin();
    }, []);

    //watch for page update decide to reset form variables
    useEffect(() => {
        if (page != pageRef.current) {
            pageRef.current = page;
            switch (page) {
                case Login_PageModeMap.LOGIN:
                    // case Login_PageModeMap.FIRST_TIME_LOGIN: --deprecated
                    ResetFormVariables();
                    break;
                case Login_PageModeMap.MEMBERSHIP_SELECTION:
                    // databaseInterfaceController.Queue('fetchActiveMembershipsByEmail', [
                    //     ['fetchActiveMembershipsByEmail', 'true'],
                    //     ['email', loginEmail]
                    // ]);
                    break;
                case Login_PageModeMap.PASSWORD_RESET:
                    ResetPasswordFormVariables();
                    break;
            }
        }
    }, [page]);

    //watch for retrievedMemberUsers fetch membershipStatus
    useEffect(() => {
        if (retrievedMemberUsers.length > 0) {
            let memberIDs = [] as string[];
            retrievedMemberUsers.map((memberUser: MemberUser) => {
                memberIDs.push(memberUser.memberID);
            });
            databaseInterfaceController.Queue('fetchFinalContractByMembershipIDs', [
                ['fetchFinalContractByMembershipIDs', 'true'],
                ['memberIDs', memberIDs.join(',')]
            ]);
        }
    }, [retrievedMemberUsers]);

    //watch for databaseResultActions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                if (!JSON.stringify(res).includes('_false')) {
                    let resObjs = [] as any[];

                    switch (mode) {
                        case 'fetchEmailByMemberID_Nric':

                            appContext.SetPopupMessage('Your email address is:<br/><span class="email">' + res + '</span><br/>Kindly use this email to login from the login page.');
                            appContext.SetPopupButtons(['Ok']);
                            appContext.SetPopupActions([() => SetPage(Login_PageModeMap.LOGIN)]);
                            break;
                        case 'checkMemberExistByEmail':
                            databaseInterfaceController.Queue('sendEmailVerification', [
                                ['sendEmailVerification', 'true'],
                                ['email', loginEmail]
                            ]);
                            break;
                        case 'sendEmailVerification':
                            appContext.SetOtpTitle('EMAIL VERIFICATION');
                            appContext.SetOtpMode(OTP_ModeMap.EMAIL);
                            appContext.SetOtpVerificationCode(res);
                            appContext.SetOtpSubject(loginEmail);
                            switch (page) {
                                // case Login_PageModeMap.LOGIN:
                                //     appContext.SetOtpResultAction(() => (res: boolean, resMessage: string) => {
                                //         if (res)
                                //             SetPage(Login_PageModeMap.MEMBERSHIP_SELECTION);
                                //         else {
                                //             appContext.SetPopupMessage("Account verification failed, unable to login.");
                                //         }
                                //     });
                                //     break; ---deprecated
                                case Login_PageModeMap.MEMBERSHIP_SELECTION:
                                    appContext.SetOtpResultAction(() => (res: boolean, resMessage: string) => {
                                        if (res) {
                                            databaseInterfaceController.Queue('setEmailVerifiedByUserID', [
                                                ['setEmailVerifiedByUserID', 'true'],
                                                ['userID', selectedLoginAttemptAccount.userID]
                                            ]);
                                        } else {
                                            appContext.SetPopupMessage("Email verification failed, please try again.");
                                        }
                                    });
                                    break;
                                case Login_PageModeMap.PASSWORD_LOGIN:
                                    appContext.SetOtpResultAction(() => (res: boolean, resMessage: string) => {
                                        if (res) {
                                            SetPage(Login_PageModeMap.PASSWORD_RESET);
                                        } else {
                                            appContext.SetPopupMessage("Email verification failed, please try again.");
                                        }
                                    });
                                    break;
                            }
                            break;
                        case 'setEmailVerifiedByUserID':
                                    if (
                                        selectedOtherUserInfo.password == 'null'
                                        || selectedOtherUserInfo.password == null
                                        || selectedOtherUserInfo.password.length == 0
                                    ) {
                                        SetPage(Login_PageModeMap.PASSWORD_RESET);
                                    } else {
                                        SetPage(Login_PageModeMap.PASSWORD_LOGIN);
                                    }
                                break;
                        // case 'fetchActiveMembershipsByEmail':
                        //     let resObjs = [] as any[];
                        //     try {
                        //         resObjs = JSON.parse(res) as any[];
                        //     } catch {
                        //         resObjs = res as any[];
                        //     }
                        //     const memberUsers = [] as MemberUser[];
                        //     const otherInfos = [] as OtherUserInfo[];
                        //     resObjs.map((obj: any) => {
                        //         memberUsers.push(new MemberUser(
                        //             obj['membership_registrationID'],
                        //             obj['userID'],
                        //             obj['memberID'],
                        //             obj['type'],
                        //             obj['committee_typeID'],
                        //             obj['email_verified'],
                        //             obj['status'],
                        //             obj['last_login'],
                        //             obj['nric'],
                        //             obj['date_of_birth'],
                        //             obj['datetime_created'],
                        //             obj['email'],
                        //             obj['name'],
                        //             obj['pin_number'],
                        //             obj['profile_image'],
                        //             obj['alternate_email'],
                        //             obj['salutation'],
                        //             obj['office_tel_no'],
                        //             obj['handphone_code'],
                        //             obj['handphone_no'],
                        //             obj['designation'],
                        //             obj['nature_of_work'],
                        //             obj['years_with_company'],
                        //             obj['academic_qualification'],
                        //             obj['address']
                        //         ));
                        //         otherInfos.push({ company_name: obj['company_name'], password: obj['password'], member_typeID: obj['member_typeID'] } as OtherUserInfo);
                        //     });
                        //     SetRetrievedMemberUsers([...memberUsers]);
                        //     SetRetrievedOtherUserInfos([...otherInfos]);
                        //     break; ---deprecated of unuse
                        case 'fetchAllMembershipsByEmail':
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }

                            if (resObjs.length > 0) {
                                const memberUsers = [] as MemberUser[];
                                const otherInfos = [] as OtherUserInfo[];
                                resObjs.map((obj: any) => {
                                    memberUsers.push(new MemberUser(
                                        obj['membership_registrationID'],
                                        obj['userID'],
                                        obj['memberID'],
                                        obj['type'],
                                        obj['committee_typeID'],
                                        obj['email_verified'],
                                        obj['status'],
                                        obj['last_login'],
                                        obj['nric'],
                                        obj['date_of_birth'],
                                        obj['datetime_created'],
                                        obj['datetime_updated'],
                                        obj['email'],
                                        obj['name'],
                                        obj['pin_number'],
                                        obj['profile_image'],
                                        obj['alternate_email'],
                                        obj['alternate_email_2'],
                                        obj['salutation'],
                                        obj['other_salutation'],
                                        obj['office_tel_no'],
                                        obj['handphone_code'],
                                        obj['handphone_no'],
                                        obj['designation'],
                                        obj['nature_of_work'],
                                        obj['years_with_company'],
                                        obj['academic_qualification'],
                                        obj['address']
                                    ));
                                    otherInfos.push(new OtherUserInfo(
                                        obj['company_name'],
                                        obj['member_typeID'],
                                        obj['password'],
                                        ''
                                    ));
                                });
                                SetRetrievedMemberUsers([...memberUsers]);
                                SetRetrievedOtherUserInfos([...otherInfos]);
                                SetPage(Login_PageModeMap.MEMBERSHIP_SELECTION);
                            } else {
                                //no memberships found
                                appContext.SetPopupMessage('Membership not found, please check your email and try again.');
                            }
                            break;
                        case 'fetchFinalContractByMembershipIDs':
                            try {
                                resObjs = JSON.parse(res) as any;
                            } catch {
                                resObjs = res as any;
                            }
                            const contracts = [] as MembershipContract[];
                            resObjs.map((resObj: any) => {
                                contracts.push(new MembershipContract(
                                    resObj['contractID'],
                                    resObj['paymentID'],
                                    resObj['memberID'],
                                    resObj['min_term'],
                                    resObj['max_term'],
                                    resObj['datetime_created']
                                ));
                            });
                            UpdateOtherUserInfosWithContracts(retrievedMemberUsers, retrievedOtherUserInfos, contracts);
                            break;
                        case 'updatePasswordPinNumberBy_userID':
                            appContext.SetPopupMessage('Successfully reset your password.');
                            appContext.SetPopupButtons(['Login Now']);
                            appContext.SetPopupActions([() => {
                                const password = res;
                                LoginMember(selectedLoginAttemptAccount, password);
                            }]);
                            break;
                        case 'fetchMemberByUserIDPassword':
                            console.log('fetchMemberByUserIDPassword: ' + JSON.stringify(res));
                            let resObj: any = {};
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }
                            LoginMember(new MemberUser(
                                resObj['membership_registrationID'],
                                resObj['userID'],
                                resObj['memberID'],
                                resObj['type'],
                                resObj['committee_typeID'],
                                resObj['email_verified'],
                                resObj['status'],
                                resObj['last_login'],
                                resObj['nric'],
                                resObj['date_of_birth'],
                                resObj['datetime_created'],
                                resObj['datetime_updated'],
                                resObj['email'],
                                resObj['name'],
                                resObj['pin_number'],
                                resObj['profile_image'],
                                resObj['alternate_email'],
                                resObj['alternate_email_2'],
                                resObj['salutation'],
                                resObj['other_salutation'],
                                resObj['office_tel_no'],
                                resObj['handphone_code'],
                                resObj['handphone_no'],
                                resObj['designation'],
                                resObj['nature_of_work'],
                                resObj['years_with_company'],
                                resObj['academic_qualification'],
                                resObj['address']
                            ), resObj['password']);
                            break;
                    }
                } else {
                    switch (mode) {
                        case 'fetchEmailByMemberID_Nric':
                            appContext.SetPopupMessage('No user found, please check your Membership and NRIC No.');
                            console.log('fetchEmailByMemberID_NricErr ' + res);
                            break;
                        case 'checkMemberExistByEmail':
                            appContext.SetPopupMessage('No user found under this email please check and try again.');
                            console.log('checkMemberExistByEmailErr ' + res);
                            break;
                        case 'sendVerificationCode':
                            appContext.SetPopupMessage('Fail to send verification code,\nPlease try again later.');
                            break;
                        // case 'fetchActiveMembershipsByEmail':
                        //     console.log('fetchActiveMembershipsByEmailErr: ' + res);
                        //     break; ---deprecated of unuse
                        case 'fetchAllMembershipsByEmail':
                            console.log('fetchAllMembershipsByEmailErr: ' + res);
                            break;
                        case 'fetchFinalContractByMembershipIDs':
                            console.log('fetchFinalContractByMembershipIDsErr: ' + res);
                            break;
                        case 'updatePasswordPinNumberBy_userID':
                            console.log('updatePasswordPinNumberBy_userIDErr: ' + res);
                            break;
                        case 'fetchMemberByUserIDPassword':
                            if(JSON.stringify(res).includes('_false')) {
                                console.log('fetchMemberByUserIDPasswordErr: ' + JSON.stringify(res));
                                appContext.SetPopupMessage('Log in session expired, please login using you email address.');
                                //remove user
                                appContext.SetStorageRequestMode('remove user');
                                appContext.SetStorageRequestParams(['user:userID', 'user:password', 'user:pin_number', 'system:viewMode']);
                            }
                            break;
                        case 'setEmailVerifiedByUserID':
                            console.log('setEmailVerifiedByUserIDErr: ' + res);
                            break;
                        case 'loginSuccess':
                            console.log('loginSuccessErr: ' + res);
                            break;
                        // case 'loginMember':
                        //     appContext.SetPopupMessage('Member does not exist,\nPlease check and try again!');
                        //     break;
                        // case 'loginCommitteeViaEmailPassword':
                        //     appContext.SetPopupMessage('Committee does not exist,\nPlease check and try again!');
                        //     break;
                        // case 'fetchMemberByMemberIDEmailPassword':
                        //     appContext.SetPopupMessage('Failed to login user\nPlease contact support.');
                        //     break;
                        // case 'fetchMemberByUserIDPassword':
                        //     console.log('fetchMemberByUserIDPassword: ' + res);
                        //     break;
                        // case 'checkUserNotActivated':
                        //     if (res.includes('userNotFound')) {
                        //         appContext.SetPopupMessage("There's no account registered under this membership no and email,\nPlease check and try again.");
                        //     } else if (res.includes('userActivated')) {
                        //         switch (page) {
                        //             // case Login_PageModeMap.FIRST_TIME_LOGIN:
                        //             //     appContext.SetPopupMessage("This user has already been activated,\nyou may select one of the option below.");
                        //             //     appContext.SetPopupButtons(['Go To Login Page', 'Forgot & Reset\nPassword']);
                        //             //     appContext.SetPopupActions([() => {/*pageRef.current = Login_PageModeMap.LOGIN;*/ SetPage(Login_PageModeMap.LOGIN); }, () => { /*pageRef.current = Login_PageModeMap.FORGOT_PASSWORD;*/ SetPage(Login_PageModeMap.FORGOT_PASSWORD); }]);
                        //             //     break; ---deprecated
                        //             // case Login_PageModeMap.FORGOT_PASSWORD:
                        //             //     databaseInterfaceController.Queue('sendVerificationCode', [
                        //             //         ['sendEmailVerification', loginEmail]
                        //             //     ]);
                        //             //     break;
                        //         }
                        //     }
                        //     break;
                        // case 'resetPassword':
                        //     appContext.SetPopupMessage('Reset password failed, please try again later.');
                        //     console.log('resetPasswordErr: ' + res);
                        //     break;
                        // case 'fetchUnActivatedMembershipsByEmail':
                        //     console.log('fetchUnActivatedMembershipsByEmailErr: ' + res);
                        //     break; ---attempt deprecated
                    }
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchEmailByMemberID_Nric':
                case 'checkMemberExistByEmail':
                case 'sendEmailVerification':
                // case 'fetchActiveMembershipsByEmail': ---deprecatedof unuse
                case 'fetchAllMembershipsByEmail':
                case 'fetchFinalContractByMembershipIDs':
                case 'updatePasswordPinNumberBy_userID':
                case 'fetchMemberByUserIDPassword':
                case 'setEmailVerifiedByUserID':
                    ExecuteDatabaseResultAction();
                    break;
                // case 'loginMember':
                // case 'loginCommitteeViaEmailPassword':
                // case 'fetchMemberByMemberIDEmailPassword':
                // case 'fetchMemberByUserIDPassword':
                // case 'checkUserNotActivated':
                // case 'resetPassword':
                // case 'fetchUnActivatedMembershipsByEmail': ---attempt deprecated
            }
        }
    }, [appContext.databaseActionModeQueue[0], appContext.databaseResultAction]);

    //watch for storageResultActions
    useEffect(() => {
        if (appContext.storageRequestMode != null && appContext.storageRequestResultAction != null) {
            const res = appContext.storageRequestResultAction();
            switch (appContext.storageRequestMode) {
                case 'get user':
                    if (res['userID'] != undefined && res['password'] != undefined) {
                        if (res['pin_number'] != undefined && res['pin_number'] != 'null') {
                            if (res['pin_number'] != '') {
                                //added pin_number layer of security to not autologin directly
                                setTimeout(() => {
                                    appContext.SetPinNumberVerificationKey(res['pin_number']);
                                    appContext.SetPinNumberVerificationMessage('Key in your 6-digit pin to login');
                                    appContext.SetPinNumberSuccessAction(() => () => {
                                        appContext.SetPinNumberVerificationKey('');
                                        //proceed to fetch from db and login
                                        databaseInterfaceController.Queue('fetchMemberByUserIDPassword', [
                                            ['fetchMemberByUserIDPassword', 'true'],
                                            ['userID', res['userID']],
                                            ['hashedPassword', res['password']]
                                        ]);
                                    });
                                    appContext.SetPinNumberResetPinAction(() => () => {
                                        appContext.SetPinNumberVerificationKey('');
                                        appContext.SetPopupMessage('Login into your account, Under Profile > General Settings > Reset 6-Digits Pin.');
                                        appContext.SetPopupButtons(['Ok']);
                                    });
                                }, 0);
                            } else {
                                //bypass pin number, auto login
                                //proceed to fetch from db and login
                                databaseInterfaceController.Queue('fetchMemberByUserIDPassword', [
                                    ['fetchMemberByUserIDPassword', 'true'],
                                    ['userID', res['userID']],
                                    ['hashedPassword', res['password']]
                                ]);
                            }
                        }
                        if (res['viewMode'] != undefined) {
                            exAppContext.SetViewMode(res['viewMode']);
                        }
                    } else {
                        // no initial user login found, not auto login
                    }
                    break;
            }
        }
    }, [appContext.storageRequestMode, appContext.storageRequestResultAction]);

    //ui functions
    //LOGIN
    const OnOpenPrivacyPolicyClicked = async () => {
        appContext.SetAppStateChangeWatch(false);
        await Browser.open({ url: 'https://www.gettix2u.com/ppkm/mobile_backend/pages/privacy-policy.php' });
        Browser.addListener('browserFinished', () => {
            appContext.SetAppStateChangeWatch(true);
        });
    }
    const OnLoginBtnClicked = () => {
        console.log('loginBtnClcked!');;
        // databaseInterfaceController.Queue('checkMemberExistByEmail', [
        //     ['checkMemberExistByEmail', 'true'],
        //     ['email', loginEmail]
        // ]); --- deprecated
        databaseInterfaceController.Queue('fetchAllMembershipsByEmail', [
            ['fetchAllMembershipsByEmail', 'true'],
            ['email', loginEmail]
        ]);
    }
    //EMAIL_RETRIEVE
    const OnRetrieveEmailClicked = () => {
        databaseInterfaceController.Queue('fetchEmailByMemberID_Nric', [
            ['fetchEmailByMemberID_Nric', 'true'],
            ['memberID', emailRetrieveMemberID],
            ['nric', emailRetrieveNRIC.replace(/[-]/g, '')]
        ]);
    }
    //MEMBERSHIP_SELECTION
    const OnProceedToLoginSelectedMembership = () => {
        if (
            selectedOtherUserInfo.status == OtherUserInfo_StatusMap.ACTIVE
            || selectedOtherUserInfo.member_typeID == 'MTYPE-000006'
        ) {
            if (!selectedLoginAttemptAccount.email_verified) {
                databaseInterfaceController.Queue('sendEmailVerification', [
                    ['sendEmailVerification', 'true'],
                    ['email', selectedLoginAttemptAccount.email]
                ]);
            } else {
                if (
                    selectedOtherUserInfo.password == 'null'
                    || selectedOtherUserInfo.password == null
                    || selectedOtherUserInfo.password.length == 0
                ) {
                    SetPage(Login_PageModeMap.PASSWORD_RESET);
                } else {
                    SetPage(Login_PageModeMap.PASSWORD_LOGIN);
                }
            }
        } else {
            appContext.SetPopupMessage("Cannot proceed login.\nThe selected membership is currently inactive.");
        }
    }
    //PASSWORD_LOGIN
    const OnAttemptProceedLoginClicked = () => {
        const loginPasswordMD5 = CryptoJS.MD5(loginPassword).toString(CryptoJS.enc.Hex);
        if (loginPasswordMD5 == selectedOtherUserInfo.password) {
            //Login Success
            LoginMember(selectedLoginAttemptAccount, selectedOtherUserInfo.password)
        } else {
            //Login Failed
            appContext.SetPopupMessage('Password Incorrect, please check and try again.');
        }
    }
    const LoginMember = async(user: MemberUser, password: string) => {
        appContext.SetUser(user);
        appContext.SetStorageRequestMode('set user');
        appContext.SetStorageRequestParams([
            ['user:userID', user.userID],
            ['user:password', password],
            ['user:pin_number', user.pin_number],
            ['system:viewMode', exAppContext.viewMode],
            ['system:newbiePrompt', 'false']
        ]);
        if (appContext.user.memberID == '') {
            exAppContext.SetViewMode(App_ViewModeMap.COMMITTEE);
        } else {
            exAppContext.SetViewMode(App_ViewModeMap.MEMBER);
        }
    }
    //PASSWORD_RESET
    const OnResetLoginClicked = () => {
        const hashedPassword = CryptoJS.MD5(resetNewPassword).toString(CryptoJS.enc.Hex);
        const hashedPinNumber = enablePin ? CryptoJS.MD5(resetNewPin).toString(CryptoJS.enc.Hex) : '';
        //update local
        SetSelectedLoginAttemptAccount(classController_memberUser.SetPropertiesOfSubject(selectedLoginAttemptAccount, ['password', 'pin_number'], [hashedPassword, hashedPinNumber]));

        //update server
        databaseInterfaceController.Queue('updatePasswordPinNumberBy_userID', [
            ['updatePasswordPinNumberBy_userID', 'true'],
            ['userID', selectedLoginAttemptAccount.userID],
            ['password', hashedPassword],
            ['pin_number', hashedPinNumber]
        ]);
    }
    const OnPasswordResetHelpClicked = (mode: string) => {
        let message = '';
        if (mode == 'password') {
            message = 'Password is used for full verification login process.'
        } else if (mode == 'pin') {
            message = '6-Digits Pin No. is used for quick verification login process.\n\nPin No. login only available after user has login the app using password.'
        }
        appContext.SetPopupMessage(message);
    }
    const OnResetPasswordClicked = () => {
        if(!selectedLoginAttemptAccount.email_verified) {
            //email otp already sent and verified on account selection, no verification needed anymore
            SetPage(Login_PageModeMap.PASSWORD_RESET);
        }
        else {
            //verify email address before allowing to reset password
            databaseInterfaceController.Queue('sendEmailVerification', [
                ['sendEmailVerification', 'true'],
                ['email', loginEmail]
            ]);
        }
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case Login_PageModeMap.EMAIL_RETRIEVE:
                return RenderEmailRetrievePage();
            case Login_PageModeMap.LOGIN:
                return RenderLoginPage();
            case Login_PageModeMap.MEMBERSHIP_SELECTION:
                return RenderMembershipSelectionPage();
            case Login_PageModeMap.PASSWORD_LOGIN:
                return RenderPasswordLoginPage();
            case Login_PageModeMap.PASSWORD_RESET:
                return RenderPasswordResetPage();

            // case Login_PageModeMap.REFERRAL_CODE:
            //     return RenderReferralPage(); --deprecated
            // case Login_PageModeMap.FORGOT_PASSWORD:
            //     return RenderForgotPage();
            // case Login_PageModeMap.NEWBIE_PROMPT:
            //     return RenderNewbiePromptPage(); ---deprecated
            // case Login_PageModeMap.FIRST_TIME_LOGIN:
            //     return RenderFirstTimeLoginPage(); --- deprecated
            // case Login_PageModeMap.RESET_PASSWORD:
            //     return RenderResetPassword();
        }
    }
    const RenderLoginPage = () => {
        return (
            <div className='page login'>
                <div className='top-background-element' />
                <img className='logo-img' src={PPKMLogo} />
                <div className='title-block'>
                    <span className='title-lbl'>PPKM APP</span>
                    <span className='title-txt'>MALAYSIA SHOPPING MALLS ASSOCIATION</span>
                </div>
                <div className='login-menu'>
                    <div className='login-row'>
                        <span className='login-row-lbl'>Provide the email address used during registration to log in.</span>
                    </div>
                    <div className='login-row'>
                        <EmailIcon />
                        <input className='login-row-in' value={loginEmail} onChange={(e) => SetLoginEmail(e.target.value.replace(/\s/g, ''))} placeholder='Registered Email' />
                    </div>
                    <div className='login-btn-row'>
                        <button className='page-btn' onClick={() => OnLoginBtnClicked()}>Login</button>
                    </div>
                    <div className='login-row ex'>
                        <span className='login-row-lbl'>What's my email address?</span>
                        <button className='login-row-btn referral-code' onClick={() => { SetPage(Login_PageModeMap.EMAIL_RETRIEVE); }}>Retrieve Email</button>
                    </div>
                </div>
            </div>
        );
    }
    const RenderEmailRetrievePage = () => {
        return (
            <div className='page email-retrieve'>
                <div className='title-block'>
                    <button className='page-back-btn' onClick={() => SetPage(Login_PageModeMap.LOGIN)}><ArrowBackIos /></button>
                    <span className='title-block-lbl'>Retrieve Email</span>
                </div>
                <div className='page-row'>
                    <span className='page-lbl'>Enter your Membership No. and NRIC number to retrieve email addres.</span>
                </div>
                <div className='page-row'>
                    <span className='page-row-lbl'>Membership No.</span>
                    <input className='page-row-in ex' value={emailRetrieveMemberID} onChange={(e: any) => SetEmailRetrieveMemberID(e.target.value)} placeholder='Your Membership Number' />
                </div>
                <div className='page-row'>
                    <span className='page-row-lbl'>NRIC No.</span>
                    <input className='page-row-in ex' value={emailRetrieveNRIC} onChange={(e: any) => SetEmailRetrieveNRIC(FormatNricNumbers(e.target.value))} placeholder='xxxxxx-13-xxxx' />
                </div>
                <button className='page-btn' onClick={() => OnRetrieveEmailClicked()}>Retrieve Email</button>
            </div>
        )
    }
    const RenderMembershipSelectionPage = () => {
        return (
            <div className='page membership-selection'>
                <div className='title-block'>
                    <button className='page-back-btn' onClick={() => SetPage(Login_PageModeMap.LOGIN)}><ArrowBackIos /></button>
                    <span className='title-block-lbl'>
                        {
                            appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ?
                            "MEMBERSHIP SELECTION"
                            :
                            "MEMBERSHIP\nSELECTION"
                        }
                    </span>
                </div>
                <div className='page-row'>
                    <span className='page-lbl'>Select an account below you wish to proceed</span>
                </div>
                <div className='page-scroll-title'>
                    <span className='page-scroll-lbl'></span>
                    <span className='page-scroll-lbl'>Membership No.</span>
                    <span className='page-scroll-lbl'>Company/ Name</span>
                    <span className='page-scroll-lbl'>Account Type</span>
                    <span className='page-scroll-lbl'>Status</span>
                </div>
                <div className='page-scroll'>
                    {
                        retrievedMemberUsers.map((memberUser: MemberUser, i: number) => {
                            return (
                                <button className={'page-scroll-btn ' + (
                                    (Object.keys(selectedLoginAttemptAccount).length > 0 && selectedLoginAttemptAccount.memberID == memberUser.memberID) ?
                                        'selected'
                                        :
                                        ''
                                )} onClick={() => { SetSelectedLoginAttemptAccount(memberUser); SetSelectedOtherUserInfo(retrievedOtherUserInfos[i]) }}>
                                    {
                                        (Object.keys(selectedLoginAttemptAccount).length > 0 && selectedLoginAttemptAccount.memberID == memberUser.memberID) ?
                                            <RadioButtonCheckedIcon />
                                            :
                                            <RadioButtonUncheckedIcon />
                                    }
                                    <span className='page-scroll-lbl'>{memberUser.memberID}</span>
                                    <span className='page-scroll-lbl'>{
                                        IsCorporate(retrievedOtherUserInfos[i].member_typeID) ?
                                            retrievedOtherUserInfos[i].company_name
                                            :
                                            memberUser.name
                                    }</span>
                                    <span className='page-scroll-lbl'>{GetKeyOfObjectByValue(MemberUser_TypeMap, memberUser.type).toLowerCase()}</span>
                                    <span className='page-scroll-lbl ex'>{(helperFunctions.GetObjKeyFromVal(OtherUserInfo_StatusMap, retrievedOtherUserInfos[i].status) == 'ACTIVE' || retrievedOtherUserInfos[i].member_typeID == 'MTYPE-000006') ? 'ACTIVE' : 'INACTIVE'}</span>
                                </button>
                            )
                        })
                    }
                </div>
                <button className='page-btn'
                    onClick={() => OnProceedToLoginSelectedMembership()}
                    disabled={(Object.keys(selectedLoginAttemptAccount).length > 0 ? false : true)}
                >Next</button>
                {/* <button className='page-btn' onClick={() => { SetLoginMemberID(selectedMembershipAccount.memberID); SetPage(Login_PageModeMap.RESET_PASSWORD); }} disabled={(Object.keys(selectedMembershipAccount).length > 0 ? false : true)}>Next</button> */}
                {/* <button className='page-btn' onClick={() => { SetPage(Login_PageModeMap.FIRST_TIME_LOGIN) }}>Back</button> ---deprecated*/}
            </div>
        )
    }
    const RenderPasswordLoginPage = () => {
        return (
            <div className='page password-login'>
                <div className='title-block'>
                    <button className='page-back-btn' onClick={() => SetPage(Login_PageModeMap.MEMBERSHIP_SELECTION)}><ArrowBackIos /></button>
                    <span className='title-block-lbl'>
                        {
                            appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ?
                            'PASSWORD AUTHENTICATION'
                            :
                            'PASSWORD<br />AUTHENTICATION'
                        }
                    </span>
                </div>
                <span className='page-lbl'>You've selected { } to login.<br />Kindly keyin the correct password to login.</span>
                <div className='page-row'>
                    <span className='page-lbl ex'>Login As</span>
                    <div className='account-info-block'>
                        <span className='account-info-lbl'>{
                            IsCorporate(selectedOtherUserInfo.member_typeID) ?
                                selectedOtherUserInfo.company_name
                                :
                                selectedLoginAttemptAccount.name
                        }</span>
                        <span className='account-info-lbl ex'>Membership No. {selectedLoginAttemptAccount.memberID}</span>
                    </div>
                </div>
                <div className='page-row'>
                    <span className='page-lbl ex'>Password</span>
                    <div className='password-block'>
                        <div className='password-icon'><LockIcon /></div>
                        <input className='password-in' value={loginPassword} onChange={(e: any) => SetLoginPassword(e.target.value)} type={shouldShowLoginPassword ? 'TEXT' : 'PASSWORD'} placeholder='Registered Password' />
                        <button className='password-btn' onClick={() => SetShouldShowLoginPassword(!shouldShowLoginPassword)}>{shouldShowLoginPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}</button>
                    </div>
                </div>
                <button className='page-btn' onClick={() => OnAttemptProceedLoginClicked()}>Login</button>
                <div className='page-row'>
                    <div className='forgot-password-block'>
                        <span className='forgot-password-lbl'>What's my password?</span>
                        <button className='forgot-password-btn' onClick={() => { OnResetPasswordClicked() }}>Reset Password</button>
                    </div>
                </div>
            </div>
        )
    }
    const RenderPasswordResetPage = () => {
        return (
            <div className='page password-reset'>
                <div className='title-block'>
                    <button className='page-back-btn' onClick={() => {
                        if (selectedOtherUserInfo.password.length > 0) {
                            //PASSWORD_ACTIVE Account
                            SetPage(Login_PageModeMap.PASSWORD_LOGIN);
                        } else {
                            //PASSWORD_INACTIVE Account
                            SetPage(Login_PageModeMap.MEMBERSHIP_SELECTION);
                        }
                    }}><ArrowBackIos /></button>
                    <span className='title-block-lbl'>
                        {
                            appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ?
                            'PASSWORD SETUP'
                            :
                            'PASSWORD<br />SETUP'
                        }
                    </span>
                </div>
                <div className='page-scroll'>
                    <div className='page-row'>
                        <span className='page-lbl ex long'>Password Setup For</span>
                        <div className='account-info-block'>
                            <span className='account-info-lbl'>{
                                IsCorporate(selectedOtherUserInfo.member_typeID) ?
                                    selectedOtherUserInfo.company_name
                                    :
                                    selectedLoginAttemptAccount.name
                            }</span>
                            <span className='account-info-lbl ex'>Membership No. {selectedLoginAttemptAccount.memberID}</span>
                        </div>
                    </div>
                    <div className='page-row'>
                        <span className='page-instruct-lbl'>Password must be at least 8 characters long with mix alphabets, numbers, capital, small letters.</span>
                        <span className='page-lbl ex long blue'>
                            New Password
                            <button className='help-btn' onClick={() => OnPasswordResetHelpClicked('password')}><HelpIcon /></button>
                        </span>
                        <div className='password-block'>
                            <div className='password-icon blue'><LockIcon /></div>
                            <input className='password-in' value={resetNewPassword} onChange={(e: any) => SetResetNewPassword(e.target.value)} type={shouldShowResetNewPassword ? 'TEXT' : 'PASSWORD'} onBlur={(e: any) => SetResetNewPassword(CheckPasswordFormat(e.target.value))} placeholder='New Password' />
                            <button className='password-btn' onClick={() => SetShouldShowResetNewPassword(!shouldShowResetNewPassword)}>{shouldShowResetNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}</button>
                        </div>
                    </div>
                    <div className='page-row'>
                        <span className='page-lbl ex long blue'>Retype Password</span>
                        <div className='password-block'>
                            <div className='password-icon blue'><LockIcon /></div>
                            <input className='password-in' value={resetConfirmPassword} onChange={(e: any) => SetResetConfirmPassword(e.target.value)} type={shouldShowResetConfirmPassword ? 'TEXT' : 'PASSWORD'} onBlur={(e: any) => SetResetConfirmPassword(CheckPasswordFormat(e.target.value, true))} placeholder='Retype Password' />
                            <button className='password-btn' onClick={() => SetShouldShowResetConfirmPassword(!shouldShowResetConfirmPassword)}>{shouldShowResetConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}</button>
                        </div>
                    </div>
                    {/* <div className='page-row'>
                    <span className='page-instruct-lbl'>6-Digits Pin No. is used for quick verification login process.<br/>Pin No. login only available after user has login the app using password.</span>
                        <div className='page-toggle'>
                            <ToggleSlider labelA='Pin Disabled' labelB='Pin Enabled' toggled={enablePin} SetToggled={SetEnablePin} />
                        </div>
                    </div> */}
                    {
                        enablePin ?
                            <Fragment>
                                <div className='page-row'>
                                    <span className='page-lbl ex long blue'>
                                        New 6-Digits Pin
                                        {/* <button className='help-btn' onClick={() => OnPasswordResetHelpClicked('pin')}><HelpIcon /></button> */}
                                    </span>
                                    <div className='password-block'>
                                        <div className='password-icon blue'><KeyIcon /></div>
                                        <input className='password-in' value={resetNewPin} onChange={(e: any) => SetResetNewPin(e.target.value.replace(/[A-Za-z]/g, ''))} type={shouldShowResetNewPin ? 'TEXT' : 'PASSWORD'} placeholder='New Pin' onBlur={(e: any) => SetResetNewPin(CheckPinFormat(e.target.value))} />
                                        <button className='password-btn' onClick={() => SetShouldShowResetNewPin(!shouldShowResetNewPin)}>{shouldShowResetNewPin ? <VisibilityIcon /> : <VisibilityOffIcon />}</button>
                                    </div>
                                </div>
                                <div className='page-row'>
                                    <span className='page-lbl ex long blue'>Retype 6-Digits Pin</span>
                                    <div className='password-block'>
                                        <div className='password-icon blue'><KeyIcon /></div>
                                        <input className='password-in' value={resetConfirmPin} onChange={(e: any) => SetResetConfirmPin(e.target.value.replace(/[A-Za-z]/g, ''))} type={shouldShowResetConfirmPin ? 'TEXT' : 'PASSWORD'} placeholder='Retype Pin' onBlur={(e: any) => SetResetConfirmPin(CheckPinFormat(e.target.value, true))} />
                                        <button className='password-btn' onClick={() => SetShouldShowResetConfirmPin(!shouldShowResetConfirmPin)}>{shouldShowResetConfirmPin ? <VisibilityIcon /> : <VisibilityOffIcon />}</button>
                                    </div>
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    <button className='page-btn' onClick={() => OnResetLoginClicked()} disabled={IsResetPasswordReady() ? false : true}>Reset Password</button>
                </div>
            </div>
        )
    }

    //exe functions
    const ResetFormVariables = () => {
        //EMAIL_RETRIEVE
        SetEmailRetrieveMemberID('');
        SetEmailRetrieveNRIC('');
        //MEMBERSHIP_SELECTION
        SetRetrievedMemberUsers([]);
        SetRetrievedOtherUserInfos([]);
        SetSelectedLoginAttemptAccount({} as MemberUser);
        SetSelectedOtherUserInfo({} as OtherUserInfo);
        //PASSWORD_LOGIN
        SetLoginPassword('');

        // SetLoginMemberID('');
        // SetLoginEmail('');
        // SetLoginPassword('');
        // SetReferralCode('');
        // SetFirstName('');
        // SetNewPassword('');
        // SetNewConfirmPassword('');
        // SetShouldShowNewPassword(false);
        // SetShouldShowNewConfirmPassword(false);
        // memberIDEmailVerifiedRef.current = false; --unused
    }
    const ResetPasswordFormVariables = () => {
        SetResetNewPassword(''); SetResetConfirmPassword('');
        SetResetNewPin(''); SetResetConfirmPin('');

        // if (selectedLoginAttemptAccount.pin_number != '')
        //     SetEnablePin(true);
        // else
        //     SetEnablePin(false); --deprecated, pin reset hide here
    }
    const FormatNricNumbers = (value: string) => {
        const _value = value.replace(/[-\s]/g, '')

        if (_value.length > 8)
            return _value.substring(0, 6) + '-' + _value.substring(6, 8) + '-' + _value.substring(8, 12);
        else if (_value.length > 6)
            return _value.substring(0, 6) + '-' + _value.substring(6, 8);
        else
            return _value.substring(0, 6);
    }
    const AutoLogin = () => {
        //clear any leftover login user reference
        appContext.SetUser({} as MemberUser);

        //proceed autologin
        appContext.SetStorageRequestMode('get user'); //also get loginMode  together
        appContext.SetStorageRequestParams(['user:userID', 'user:password', 'user:pin_number', 'system:viewMode']);
    }
    const GetKeyOfObjectByValue = (object: any, value: any) => {
        let res = '';
        Object.keys(object).map((key: string) => {
            if (object[key] == value)
                res = key;
        });
        return res;
    }
    const UpdateOtherUserInfosWithContracts = (memberUsers: MemberUser[], otherUserInfos: OtherUserInfo[], latestContracts: MembershipContract[]) => {
        const updatedOtherUserInfos = [] as OtherUserInfo[];
        const dateNow = new Date();
        const yearNow = dateNow.getFullYear();
        const graceLoginLastDate = new Date(yearNow.toString() + '-' + nonstate.GRACE_LOGIN_LAST_DATE);

        memberUsers.map((memberUser: MemberUser, i: number) => {
            if (memberUser.status == MemberUser_StatusMap.ACTIVE) {
                const latestMembershipContract: MembershipContract | null = SearchContractByMemberID(latestContracts, memberUser.memberID);
                if (
                    latestMembershipContract != null
                    && latestMembershipContract.max_term != null
                    && (latestMembershipContract.max_term >= new Date() || graceLoginLastDate >= new Date())
                ) {
                    updatedOtherUserInfos.push(
                        classController_otherUserInfo.SetPropertiesOfSubject(otherUserInfos[i], ['status'], [OtherUserInfo_StatusMap.ACTIVE.toString()])
                    );
                } else {
                    updatedOtherUserInfos.push(
                        classController_otherUserInfo.SetPropertiesOfSubject(otherUserInfos[i], ['status'], [OtherUserInfo_StatusMap.EXPIRED.toString()])
                    );
                }
            } else {
                updatedOtherUserInfos.push(
                    classController_otherUserInfo.SetPropertiesOfSubject(otherUserInfos[i], ['status'], [OtherUserInfo_StatusMap.SUSPEND.toString()])
                );
            }
        });

        SetRetrievedOtherUserInfos([...updatedOtherUserInfos]);
    }
    const SearchContractByMemberID = (contracts: MembershipContract[], memberID: string) => {
        let res = null as MembershipContract | null;
        contracts.map((contract: MembershipContract) => {
            if (contract.memberID == memberID)
                res = contract;
        });
        return res;
    }

    //checking functions
    const CheckPasswordFormat = (value: string, isRetype: boolean = false) => {
        if (value.length > 0) {
            if (!isRetype) {
                if (value.length < 8) {
                    appContext.SetPopupMessage('Password must be at least 8 characters long.');
                    return '';
                } else if (!(value.match(/[a-z]/g) && value.match(/[A-Z]/g))) {
                    appContext.SetPopupMessage('Password must contains capital and small letters.');
                    return '';
                } else if (!value.match(/[0-9]/g)) {
                    appContext.SetPopupMessage('Password must contains numbers.');
                    return '';
                } else {
                    return value;
                }
            } else {
                if (value != resetNewPassword) {
                    appContext.SetPopupMessage('Retype password must be the same as password.');
                    return '';
                } else {
                    return value;
                }
            }
        } else
            return '';
    }
    const CheckPinFormat = (value: string, isRetype: boolean = false) => {
        if (value.length > 0) {
            if (!isRetype) {
                if (value.length != 6) {
                    appContext.SetPopupMessage('Pin number must be exactly 6 digits long.');
                    return '';
                } else {
                    return value;
                }
            } else {
                if (value != resetNewPin) {
                    appContext.SetPopupMessage('Retype 6-digits pin must be the same as new 6-digits pin.');
                    return '';
                } else {
                    return value;
                }
            }
        } else {
            return '';
        }
    }
    const IsResetPasswordReady = () => {
        if (
            resetNewPassword.length >= 8 && resetNewPassword == resetConfirmPassword
            &&
            (
                !enablePin ||
                resetNewPin.length == 6 && resetNewPin == resetConfirmPin
            )
        ) {
            return true;
        } else {
            return false;
        }
    }
    const IsCorporate = (member_typeID: string) => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                memberType.member_typeID == member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            ) {
                res = true;
            }
        });
        return res;
    }

    //states
    return (
        <div className={'Login ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                RenderPage()
            }
            <button className='privacy-policy-btn' onClick={async () => OnOpenPrivacyPolicyClicked()}>Privacy Policy</button>
        </div>
    );
}
export default Login;